import React, { useState, useEffect } from 'react';
import './ImagePopup.css';

interface ImagePopupProps {
  imageUrl: string;
  imageAlt?: string;
  linkUrl?: string;
  linkText?: string;
  title?: string;
  openInNewTab?: boolean;
  startDate?: string | Date;
  endDate?: string | Date;
  onDateExpired?: () => void;
  showDateInfo?: boolean;
  timezone?: string;
}

const ImagePopup: React.FC<ImagePopupProps> = ({
  imageUrl,
  imageAlt = 'Popup Image',
  linkUrl,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  // Fechar com ESC
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Fechar ao clicar no backdrop
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setIsOpen(false);
    }
  };

  // Não renderizar se não estiver aberto
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={handleBackdropClick}>
      <div className="popup-container">
        <button
          className="popup-close-btn"
          onClick={() => setIsOpen(false)}
          aria-label="Fechar popup"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {title && (
          <div className="popup-header">
            <h2 className="popup-title">{title}</h2>
          </div>
        )}
        <a
          className="popup-image-container"
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={imageUrl}
            alt={imageAlt}
            className="popup-image"
            onError={e => {
              console.error('Erro ao carregar imagem:', imageUrl);
              e.currentTarget.src = '/placeholder-image.png';
            }}
          />
        </a>
      </div>
    </div>
  );
};

export default ImagePopup;
